<template>
  <div class="copy-to-clipboard input-with-button">
    <div class="input-with-button__input">
      <text-input
        type="text"
        :label="label"
        :name="name"
        :icon-class="iconClass"
        :prevent-input="true"
        :select-all-on-focus="true"
        :model-value="value"
      />
    </div>

    <div
      v-if="nativeShareEnabled"
      class="input-with-button__button"
    >
      <button
        class="button button--primary button--icon"
        type="button"
        @click="shareNatively"
      >
        <span class="icon far fa-external-link" />
      </button>
    </div>

    <div
      v-else
      class="input-with-button__button"
    >
      <button
        :id="`${name }-button`"
        :data-clipboard-text="value"
        class="button button--primary button--icon"
        type="button"
      >
        <span class="icon far fa-cut" />
      </button>
    </div>
  </div>
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import events from '@/services/events';
  import Clipboard from 'clipboard';



  export default {
    name: 'CopyToClipboard',

    props: {
      iconClass: {
        type: String,
        default: 'fa-link'
      },

      isUrl: {
        type: Boolean,
        default: true
      },

      label: {
        type: String,
        required: true
      },

      name: {
        type: String,
        required: true
      },

      value: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        clipboard: null,
        nativeShareEnabled: false
      };
    },

    created() {
      this.createdHandler();
    },

    unmounted() {
      this.destroyedHandler();
    },

    mounted() {
      this.mountedHandler();
    },

    methods: {
      clipboardCopyError() {
        events.emit('notification', {
          type: 'error',
          message: 'Failed to copy to clipboard.'
        });
      },

      clipboardCopySuccess() {
        events.emit('notification', {
          type: 'success',
          message: 'Copied to clipboard!'
        });
      },

      createdHandler() {
        this.nativeShareEnabled = !!window.navigator.share;
      },

      destroyedHandler() {
        if (this.clipboard) {
          this.clipboard.destroy();
        }
      },

      mountedHandler() {
        if (!this.nativeShareEnabled) {
          this.clipboard = new Clipboard(`#${this.name}-button`);
          this.clipboard.on('error', this.clipboardCopyError);
          this.clipboard.on('success', this.clipboardCopySuccess);
        }
      },

      async shareNatively() {
        try {
          const details = {};

          if (this.isUrl) {
            details.url = this.value;
          }
          else {
            details.text = this.value;
          }

          await window.navigator.share(details);
        }

        catch (error) {
          errorHandlers.silent(error);
        }
      }
    }
  };
</script>
